import { useEffect, useMemo, useState } from 'react';
import { AuthorizationsFilter } from '../models';
import { useQueryParams } from '@/hooks';
import dayjs from 'dayjs';

const useAuthorizationsFilter = () => {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: AuthorizationsFilter = useMemo(() => {
    return {
      status: undefined,
      requestDriverId: undefined,
      authorizationUserId: undefined,
      requestedFrom: dayjs().startOf('day').toISOString(),
      requestedTo: dayjs().endOf('day').toISOString(),
    };
  }, []);

  const [filter, setFilter] = useState<AuthorizationsFilter>(() => {
    return {
      status: (getQueryParam('status') as any) || initialFilter.status,
      requestDriverId: getQueryParam('requestDriverId') || initialFilter.requestDriverId,
      authorizationUserId: getQueryParam('authorizationUserId') || initialFilter.authorizationUserId,
      requestedFrom: getQueryParam('requestedFrom') || initialFilter.requestedFrom,
      requestedTo: getQueryParam('requestedTo') || initialFilter.requestedTo,
    };
  });

  useEffect(() => {
    setQueryParams({
      status: filter.status || undefined,
      requestDriverId: filter.requestDriverId || undefined,
      authorizationUserId: filter.authorizationUserId || undefined,
      requestedFrom: filter.requestedFrom || undefined,
      requestedTo: filter.requestedTo || undefined,
      page: '1',
      pageSize: getQueryParam('pageSize') || '10',
    });
  }, [filter]);

  return { filter, initialFilter, setFilter };
};

export default useAuthorizationsFilter;
